/**
 * Marketplace buyer auth kontraktlari (Faza 3) — telefon OTP.
 *
 * Oqim: otpRequest (telefon) → SMS kod (Eskiz) → otpVerify (telefon+kod) →
 * MARKETPLACE_JWT (server JWT'dan ALOHIDA secret). Telefon normalizatsiyasi
 * mavjud common phoneSchema'dan (dublikat yo'q).
 */
import { z } from 'zod';
import { phoneSchema } from './common.schema.js';
// ─── OTP so'rash ──────────────────────────────────────────────────
export const otpRequestSchema = z.object({
    phone: phoneSchema,
});
// ─── OTP tasdiqlash ───────────────────────────────────────────────
export const otpVerifySchema = z.object({
    phone: phoneSchema,
    code: z
        .string()
        .trim()
        .regex(/^\d{6}$/, '6 xonali kod kiriting'),
});
// ─── Buyer profil ─────────────────────────────────────────────────
export const marketplaceProfileSchema = z.object({
    name: z.string().trim().min(1, 'Ism kiriting').max(120).optional(),
});
// ─── Manzil ───────────────────────────────────────────────────────
export const marketplaceAddressSchema = z.object({
    region: z.string().trim().min(1, 'Viloyat kerak').max(120),
    district: z.string().trim().min(1, 'Tuman kerak').max(120),
    address: z.string().trim().min(1, 'Manzil kerak').max(300),
    landmark: z.string().trim().max(200).optional(),
    geoLat: z.number().min(-90).max(90).optional(),
    geoLng: z.number().min(-180).max(180).optional(),
    isDefault: z.boolean().optional(),
});
//# sourceMappingURL=marketplace-auth.schema.js.map